import { MeasurableGroupType } from './types';

// TODO ML: This file contains duplicate information with weighting.ts. Rework to have a single definition
// for how a group type behaves.

// TODO OH: Note that get-weighting-field.ts has also information related to how a group type is weighted

export function hasWeights(groupType: MeasurableGroupType | undefined) {
  switch (groupType) {
    case MeasurableGroupType.FUND:
    case MeasurableGroupType.CLIENTS:
    case MeasurableGroupType.WEIGHTED_PORTFOLIO:
    case MeasurableGroupType.WEIGHTED_PORTFOLIO_PRIVATE:
    case MeasurableGroupType.LOANS:
    case MeasurableGroupType.GRANT_RECIPIENTS:
    case MeasurableGroupType.INDEX:
      return true;
    case MeasurableGroupType.GENERIC:
    case MeasurableGroupType.UNWEIGHTED_PORTFOLIO:
      return false;
    default:
      return false;
  }
}

export function hasItemValues(groupType: MeasurableGroupType | undefined) {
  switch (groupType) {
    case MeasurableGroupType.FUND:
    case MeasurableGroupType.CLIENTS:
    case MeasurableGroupType.WEIGHTED_PORTFOLIO:
    case MeasurableGroupType.WEIGHTED_PORTFOLIO_PRIVATE:
    case MeasurableGroupType.LOANS:
    case MeasurableGroupType.GRANT_RECIPIENTS:
      return true;
    default:
      return false;
  }
}

export function hasRevenueWeights(groupType: MeasurableGroupType | undefined) {
  switch (groupType) {
    case MeasurableGroupType.GENERIC:
      return true;
    default:
      return false;
  }
}

// Formerly known as "hasPercentageWeights"
export function hasWeightsOnly(groupType: MeasurableGroupType | undefined) {
  return hasWeights(groupType) && !hasItemValues(groupType);
}

export function mayHaveNegativeWeights(type: MeasurableGroupType | undefined) {
  switch (type) {
    case MeasurableGroupType.FUND:
    case MeasurableGroupType.WEIGHTED_PORTFOLIO:
    case MeasurableGroupType.WEIGHTED_PORTFOLIO_PRIVATE:
      return true;
    default:
      return false;
  }
}
